var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart34-template',{attrs:{"board-ids":[348],"data-type":_vm.dataType,"field-code":"facility","graph-id":73,"title":"(시설물)안전·보건 확보 의무 현황","unit":"건","orientation":_vm.orientation}})
}
var staticRenderFns = []

export { render, staticRenderFns }